module.exports = __webpack_public_path__ + "static/img/ewm.0f549eec.jpg";